import React from 'react';

export const LogOutIcon = () => (
  <div
    style={{
      marginRight: '10px',
      height: '20px',
      width: '20px',
      backgroundImage: 'url("/images/shutdown_button.svg")',
      backgroundSize: '23px 23px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'inline-block'
    }}
  />
);
